<template>
    <div class="pages">
        <!-- 快捷栏 -->
        <shortcut-bar class="shortcut-bar page-header" />
        <div class="page-header-placeholder"></div>

        <div class="box">
            <div class="boxBreadcrumb">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">{{ $t('首页') }}</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/user-center/0/my-order2' }">{{ $t('我的订单') }}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{ $t('订单详情') }}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>

            <div class="refund-option-card" :class="{ 'is-h5': isH5 }">
                <div class="box-xinxi">
                    <img :src="tableData.product_image" alt="" class="xinxi-img">
                    <div class="xinxi-right">
                        <div class="text-14">
                            <div class="margin-bottom-8">{{ tableData.product_title }}</div>
                            <div class="text-999">{{ tableData.product_sku_text }}</div>
                        </div>
                        <div class="text-20 text-85674B">￥{{ tableData.product_price }}</div>
                    </div>
                </div>

                <div class="box-type">
                    <div class="type-tit">{{ $t('选择售后类型') }}</div>
                    <div class="flex flex-wrap type-list">
                        <div class="type-box" @click="onRefund(item)" v-for="(item, index) in list" :key="index">
                            <img :src="item.img" alt="">
                            <span>{{ item.txt }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 左侧悬浮框 -->
        <div class="pc-float">
            <leftSuspension />
        </div>

        <footer-bar></footer-bar>
    </div>
</template>

<script>
import ShortcutBar from '@/components/ShortcutBar'
// import { myOrderDetail, afterSaleType } from '@/api/user'
import leftSuspension from "@/components/leftSuspension.vue";
import { orderDetail } from '@/api/user';
import footerBar from '@/components/footerBar';

export default {
    name: 'UserCenter',
    components: {
        'footer-bar': footerBar,
        'shortcut-bar': ShortcutBar,
        leftSuspension,
    },
    data() {
        return {
            id: '',//订单id
            tableData: {},//订单
            after_sale_type: [],//售后类型
            items: [],//商品信息
            list: [{
                img: require('../../../static/images/icon/icon09.png'),
                txt: this.$t('我要退款(无需退货)'),
                type: 'refund',
            }, {
                img: require('../../../static/images/icon/icon10.png'),
                txt: this.$t('我要退货退款'),
                type: 'return',
            }],//退款方式
            isH5: typeof window !== 'undefined' && window.innerWidth < 768,
        }
    },
    computed: {

    },
    mounted() {
        this.updateIsH5();
        window.addEventListener('resize', this.updateIsH5);
        // console.log(JSON.parse(decodeURIComponent(this.$route.params.order)));
        this.tableData = JSON.parse(decodeURIComponent(this.$route.params.order))

        // this.id = this.$route.params.order;
        // this.onOrderDetail()
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateIsH5);
    },
    methods: {
        updateIsH5() {
            this.isH5 = window.innerWidth < 768;
        },
        /**订单详情 */
        onOrderDetail() {
            orderDetail({ id: this.id }).then(res => {
                let data = res.data
                this.items = data.items
                // console.log(data);
            })
        },
        /**售后类型 */
        onAfterSaleType() {
            afterSaleType().then(res => {
                this.after_sale_type = res.data
            })
        },
        /**去退款 */
        onRefund(e) {
            /**
             * i为1  仅退款
             * i为2  退货退款
             */
            this.$router.push({ name: 'Refund', params: { order: encodeURIComponent(JSON.stringify(this.tableData)), type: e.type } });
        },
        /**订单详情 */
        onDetail() {
            myOrderDetail(this.id).then(res => {
                let data = res.data
                let tableData = data.shops[0].items
                tableData.forEach(item => {
                    item.specList = JSON.parse(item.spec)
                })
                this.tableData = tableData
                // this.orderDetali = data
                console.log(this.tableData);
            })
        },
    }
};
</script>

<style scoped lang="scss">
.page-header {
    z-index: 999;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
}

.page-header-placeholder {
    height: 56px;
}

.box {
    padding: 0 var(--page-gutter-wide);
    min-height: 80vh;
}

/*面包屑*/
.boxBreadcrumb {
    padding: 24px 0 32px 0;
}

.refund-option-card {
    box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    padding: 32px 60px;
}

/**订单内容 */
.box-box {
    padding: 24px;
    background: #FFFFFF;
    border-radius: 8px;
    height: calc(100vh - 200px);
}

.box-xinxi {
    margin-bottom: 24px;
    display: flex;

    .xinxi-img {
        width: 120px;
        height: 120px;
        border-radius: 8px;
        object-fit: cover;
        object-position: center;
        flex-shrink: 0;
    }

    .xinxi-right {
        width: 360px;
        margin-left: 16px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .right-sku {
            font-size: 14px;
            color: #999999;
        }

        .right-price-l {
            font-size: 16px;
            color: #999999;
            text-decoration-line: line-through;
        }

        .right-price-r {
            margin-left: 8px;
            font-weight: bold;
            font-size: 16px;
            color: #FD3B00;
        }
    }
}

.box-type {
    .type-tit {
        font-size: 16px;
        color: #333333;
        margin-bottom: 16px;
    }

    .type-box {
        width: 320px;
        height: 100px;
        background: #FFFFFF;
        border-radius: 8px;
        border: 1px solid #BFBFBF;
        margin-right: 32px;
        cursor: pointer;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;

        img {
            width: 36px;
            height: 36px;
            margin-right: 12px;
        }
    }
}

@media (max-width: 767px) {
    .pages {
        overflow-x: hidden;
        width: 100%;
        background: #f5f6f8;
    }

    .page-header {
        padding-top: env(safe-area-inset-top, 0px);
    }

    .page-header-placeholder {
        height: calc(56px + env(safe-area-inset-top, 0px));
    }

    .pc-float {
        display: none;
    }

    .box {
        padding: 0 12px 24px;
        box-sizing: border-box;
        min-height: auto;
    }

    .boxBreadcrumb {
        padding: 10px 0 12px;
        overflow-x: auto;
        white-space: nowrap;
        font-size: 12px;
    }

    .refund-option-card.is-h5 {
        box-shadow: none;
        border-radius: 0;
        padding: 0;
        background: transparent;
        display: flex;
        flex-direction: column;
        gap: 12px;

        .box-xinxi {
            margin-bottom: 0;
            background: #fff;
            border-radius: 8px;
            padding: 12px;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);

            .xinxi-img {
                width: 80px;
                height: 80px;
                flex-shrink: 0;
                object-fit: cover;
            }

            .xinxi-right {
                width: calc(100% - 80px);
                margin-left: 12px;
                min-width: 0;

                .text-14 {
                    font-size: 13px;
                }

                .text-20 {
                    font-size: 18px;
                }
            }
        }

        .box-type {
            background: #fff;
            border-radius: 8px;
            padding: 12px;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);

            .type-tit {
                font-size: 15px;
                font-weight: 600;
                margin-bottom: 12px;
            }

            .type-list {
                flex-direction: column;
                gap: 12px;
            }

            .type-box {
                width: 100%;
                height: 56px;
                margin-right: 0;
                font-size: 15px;
                border-color: #e8e8e8;
                box-sizing: border-box;
                transition: transform 0.15s ease, opacity 0.15s ease;

                &:active {
                    transform: scale(0.98);
                    opacity: 0.88;
                }

                img {
                    width: 28px;
                    height: 28px;
                    margin-right: 10px;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/afterSale/RefundOption.vue